export const formatCurrentDate = (date: string) => {
  const publishedAt = new Intl.DateTimeFormat("fr-FR", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  }).format(new Date(date))

  return publishedAt
}
